var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWbgVegetablesV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F6FFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0885 16.2183L19.2832 17.117L16.9824 15.769C16.7523 15.6567 16.4072 15.6567 16.1771 15.9937C15.947 16.3307 16.062 16.5553 16.4072 16.78L18.4779 18.0156L14.5665 22.2842L12.4957 21.0486C12.2656 20.9363 11.9205 20.9363 11.6904 21.2733C11.5754 21.4979 11.5754 21.8349 11.9205 22.0596L13.7612 23.1829L12.2656 24.8679C11.5754 25.9912 10.1948 26.3282 9.15946 25.6542C8.00903 24.9802 7.6639 23.6322 8.35416 22.6212L10.1948 17.117L11.6904 18.0156C11.9205 18.128 12.2656 18.128 12.4957 17.791C12.6108 17.5663 12.6108 17.2293 12.2656 17.0047L10.54 15.9937L12.0355 11.6127C12.8408 10.6017 14.3364 10.0401 15.947 10.3771L15.7169 7.68113C15.7169 7.00714 16.1771 6.55781 16.7523 6.44548C17.3275 6.33315 17.9027 6.89481 18.0178 7.45646L18.1328 8.35512L19.1682 6.55781C19.5133 5.99615 20.2036 5.88382 20.7788 6.10848C21.354 6.44548 21.4691 7.11947 21.239 7.68113L19.9735 9.92776L22.5044 9.02911C23.0797 8.80444 23.7699 9.14144 24 9.7031C24 10.3771 23.6549 10.9387 23.0797 11.1634L19.5133 12.3991C20.4337 13.6347 20.7788 15.095 20.0885 16.2183Z",
    fill: "#79A303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbgVegetablesV2);
export default __webpack_public_path__ + "static/media/wbg-vegetables-v2.172bea9f51842a54d6439bbc34cd9fc0.svg";
export { ForwardRef as ReactComponent };